import { render, staticRenderFns } from "./TradeRequestProcess.vue?vue&type=template&id=304aa4cc&"
import script from "./TradeRequestProcess.vue?vue&type=script&lang=js&"
export * from "./TradeRequestProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports